import { Typography, Grid, Card, CardContent, useTheme, alpha } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { Service as ServiceType } from "0.Mine/3.Interfaces/customer";

export const ServiceCard: React.FC<{ service: ServiceType }> = ({ service }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <Card
      variant="outlined"
      sx={{
        mb: 2,
        borderColor: alpha(theme.palette.primary.main, 0.2),
        borderRadius: 2,
        "&:last-child": {
          mb: 0,
        },
      }}
    >
      <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">
              {t("serviceCard.service")}
            </Typography>
            <Typography variant="body1" fontWeight={500}>
              {service.serviceName}
            </Typography>
          </Grid>

          <Grid item xs={6} sm={3}>
            <Typography variant="subtitle2" color="text.secondary">
              {t("serviceCard.duration")}
            </Typography>
            <Typography variant="body1">{service.duration} min</Typography>
          </Grid>

          <Grid item xs={6} sm={3}>
            <Typography variant="subtitle2" color="text.secondary">
              {t("serviceCard.price")}
            </Typography>
            <Typography variant="body1" fontWeight={500}>
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(service.price)}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="subtitle2" color="text.secondary">
              {t("serviceCard.price")}
            </Typography>
            <Typography variant="body1">{service.staffName}</Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
